// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__33gt3","calendarButtons":"ClockData_calendarButtons__3ZvwE"};